import HealingRoundedIcon from "@mui/icons-material/HealingRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Box, Button, Divider, Paper, Stack } from "@mui/material";
import { AlertPanel } from "@/features/network-topology/AlertPanel";
import { EdgeDetailPanel } from "@/features/network-topology/EdgeDetailPanel";
import { EventsLogPanel } from "@/features/network-topology/EventsLogPanel";
import { NetworkGraph } from "@/features/network-topology/NetworkGraph";
import { NodeDetailPanel } from "@/features/network-topology/NodeDetailPanel";
import { useNetworkActions, useNetworkTopology } from "@/features/network-topology/useNetworkTopology";

/**
 * ネットワーク可視化ページ。
 *
 * レイアウト:
 *   ┌────────────────────────┬────────────────┐
 *   │  NetworkGraph         │  AlertPanel     │
 *   │   (React Flow)         ├────────────────┤
 *   │                        │  NodeDetail    │
 *   │                        ├────────────────┤
 *   │                        │  EventsLog     │
 *   └────────────────────────┴────────────────┘
 *
 * ヘッダ右側にデモ用の障害注入ボタンを配置（ランダム障害 / 全クリア / 初期化）。
 */
export function NetworkTopologyPage() {
  const { resetToDefault, injectRandomFault, clearAllFaults } = useNetworkActions();
  const { selectedEdgeChildId } = useNetworkTopology();

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          py: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          background: "#ffffff",
        }}
      >
        <Box sx={{ fontWeight: 700, fontSize: 14 }}>OT Network</Box>
        <Stack direction="row" spacing={1}>
          <Button
            size="small"
            variant="contained"
            color="warning"
            startIcon={<WarningAmberRoundedIcon />}
            onClick={() => injectRandomFault()}
          >
            ランダム障害注入
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="success"
            startIcon={<HealingRoundedIcon />}
            onClick={clearAllFaults}
          >
            異常を全クリア
          </Button>
          <Button size="small" variant="outlined" startIcon={<RestartAltRoundedIcon />} onClick={resetToDefault}>
            初期化
          </Button>
        </Stack>
      </Stack>
      <Box sx={{ flex: 1, display: "flex", minHeight: 0 }}>
        <Box sx={{ flex: 1, position: "relative", minWidth: 0 }}>
          <NetworkGraph />
        </Box>
        <Paper
          square
          elevation={0}
          sx={{
            width: 320,
            display: "flex",
            flexDirection: "column",
            borderLeft: "1px solid",
            borderColor: "divider",
            overflow: "hidden",
          }}
        >
          <Box sx={{ flexShrink: 0 }}>
            <AlertPanel />
          </Box>
          <Divider />
          <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
            {selectedEdgeChildId ? <EdgeDetailPanel /> : <NodeDetailPanel />}
          </Box>
          <Divider />
          <Box sx={{ flex: 1, minHeight: 0, display: "flex" }}>
            <EventsLogPanel />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
